import React, { } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';

/**
 *
 */
function StepInfo({ step, loading }) {
  /**
   *
   * @return {JSX.Element}
   */

  return (
    <div className="zoho-step-info-wrapper">
      {loading
        ? (
          <div className="zoho-step-info-loading__wrapper">
            {[1, 2]?.map((item) => (
              <div key={item} className="zoho-step-info-loading-line">
                <div className="loadingBlock zoho-step-info-loading-dot" />
                <div className="loadingBlock zoho-step-info-loading-text" />
              </div>
            ))}
          </div>
        )
        : (
          <div style={{ marginTop: '35px' }} className="zoho-step-border">
            <div className="zoho-step-info-status-wrapper">
              <div className={`dot  ${ step === 1 ? 'dot-blue' : 'dot-green'} `} />
              <div className="zoho-step-info-status-heading-active">&nbsp;Map Locations</div>
            </div>
            <div className="zoho-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 2 ? 'dot-blue' : step > 2 && 'dot-green' }`} />
              <div className="zoho-step-info-status-heading-active">&nbsp;Sync Data</div>
            </div>
            <div className="zoho-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 3 ? 'dot-blue' : step > 3 && 'dot-green' }`} />
              <div className="zoho-step-info-status-heading-active">&nbsp;Review & Save</div>
            </div>
          </div>
        )}
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});
StepInfo.propTypes = {
  step: PropTypes.any,
  loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StepInfo));
